import React, { useState, useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { LoadingBlueLarge } from 'merchant-portal-components';
import PaginationControl from '../Pagination/PaginationControl';
import { Button } from 'merchant-portal-components';
import { Checkbox, TextField, InputAdornment } from '@material-ui/core';
import { Dialog } from '@material-ui/core';
import {
  StyledCard,
  HeaderWrapper,
  SearchWrapper,
  SectionTitle,
  LocationsCounter,
  RowWrapper,
  TH,
  TD,
  PaginationWrapper,
  ButtonWrapper,
  Left,
  Right,
  CancelButton,
  CloseIcon,
} from './filterModalStyles';
import * as actions from '../../modules/OfferEngine/OfferEngineActions';
import { paginate } from './paginate';

const initialRequestParams = {
  page_number: 1,
  page_size: '10',
  sorting_option: 'title-asc',
};
const FilterOfferModal = ({
  allOffers,
  requestParams,
  filteredOffers,
  setFilteredOffers,
  isOpen,
  setIsOpen,
  placeholder,
  searchLabel,
  formField,
  isEmptyAccepted,
  getOffersEngine,
  updateOffersRequestParams,
  clearOffersList,
}) => {
  delete requestParams.has_next_page;
  //
  const [selectedOffers, setSelectedOffers] = useState(filteredOffers || []);
  const [currentPageOffers, setCurrentPageOffers] = useState([]);
  const [offerListLength, setProductListLength] = useState([]);
  const [searchedOffers, setSearchedOffers] = useState([]);
  const [searchString, setSearchString] = useState('');

  useEffect(() => {
    clearOffersList();
    getOffersEngine({
      page_number: 1,
      page_size: '1000',
      search_string: '',
    });
    updateOffersRequestParams(initialRequestParams);
    return () => {
      updateOffersRequestParams(initialRequestParams);
    };
  }, [getOffersEngine, updateOffersRequestParams, clearOffersList]);

  //
  const updateInitials = useCallback(() => {
    if (allOffers && filteredOffers.length === 0 && isEmptyAccepted) {
      const newAllOffers = allOffers.map((offer) => offer.offer_id);
      setSelectedOffers(newAllOffers.sort());
    }
  }, [allOffers]);
  useEffect(() => {
    updateInitials();
  }, [updateInitials]);

  const filterProductList = useCallback(() => {
    let filteredList = allOffers;
    if (searchString) {
      filteredList = filteredList?.filter((item) =>
        item.title?.toLowerCase().includes(searchString?.toLowerCase())
      );
    }
    let paginatedList = paginate(
      filteredList,
      requestParams.page_number,
      requestParams.page_size
    );
    setSearchedOffers(filteredList);
    setCurrentPageOffers(paginatedList);
    setProductListLength(filteredList.length);
  }, [
    requestParams.page_number,
    requestParams.page_size,
    selectedOffers,
    allOffers,
    searchString,
  ]);
  useEffect(() => {
    filterProductList();
  }, [filterProductList]);

  useEffect(() => {
    if (allOffers?.length > 0) {
      const filteredList = allOffers?.filter((item) =>
        item.title?.toLowerCase().includes(searchString?.toLowerCase())
      );
      setSearchedOffers(filteredList);
      const paginatedList = paginate(filteredList, 1, requestParams.page_size);
      updateOffersRequestParams({ ...requestParams, page_number: 1 });
      setCurrentPageOffers(paginatedList);
      setProductListLength(filteredList.length);
    }
  }, [searchString, allOffers]);
  ///
  useEffect(() => {}, []);
  const handleAssignOffers = (e, id) => {
    let newSelectedOffers = [...selectedOffers];
    let isSelected = selectedOffers.includes(id);
    if (isSelected) {
      newSelectedOffers = selectedOffers.filter(
        (currentId) => currentId !== id
      );
    } else {
      newSelectedOffers.push(id);
    }
    setSelectedOffers(newSelectedOffers);
  };
  const handleAssignAllOffers = (e) => {
    let isSelected = e.target.checked;
    let newSelectedOffers = [];
    if (isSelected) {
      searchedOffers.map((offer) => {
        newSelectedOffers.push(offer.offer_id);
      });
    }
    setSelectedOffers(newSelectedOffers);
  };
  const handleAddOffers = () => {
    const isAllProductSelected = allOffers.length === selectedOffers.length;
    let newSelectedOffers =
      isAllProductSelected && isEmptyAccepted ? [] : selectedOffers;
    if (formField) {
      setFilteredOffers(formField, newSelectedOffers);
    } else {
      setFilteredOffers(newSelectedOffers);
    }
    setIsOpen(false);
  };
  const handleReset = () => {
    if (filteredOffers.length === 0 && !isEmptyAccepted) {
      const newAllOffers = allOffers.map((offer) => offer.offer_id);
      setSelectedOffers(newAllOffers.sort());
    } else {
      setSelectedOffers(filteredOffers.sort());
    }
  };
  const isSaveDisabled = () => {
    let isDisabled = true;
    let isEqual = _.isEqual(filteredOffers.sort(), selectedOffers.sort());

    if (allOffers) {
      if (isEmptyAccepted && !isEqual) {
        isDisabled = false;
      } else if (!isEmptyAccepted && selectedOffers.length !== 0 && !isEqual) {
        isDisabled = false;
      }
    }
    return isDisabled;
  };
  console.log('request', requestParams);
  return (
    <Dialog open={isOpen} fullWidth maxWidth='md'>
      <StyledCard>
        <HeaderWrapper padding='0'>
          <div>
            <SectionTitle>Offers</SectionTitle>
            <LocationsCounter>
              {`${selectedOffers.length} offers selected`}
            </LocationsCounter>
          </div>
          <div style={{ textAlign: 'right' }}>
            <CloseIcon
              className='fa fa-times'
              onClick={() => setIsOpen(false)}
            ></CloseIcon>
          </div>
        </HeaderWrapper>
        <SearchWrapper>
          <TextField
            id='outlined-basic'
            label={searchLabel}
            placeholder={placeholder}
            variant='outlined'
            style={{ width: '100%' }}
            value={searchString}
            onChange={(e) => setSearchString(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position='start'>
                  <i className='fa fa-search' style={{ color: '#b5b5b5' }}></i>
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position='end'>
                  {`${offerListLength} results`}
                </InputAdornment>
              ),
            }}
          />
        </SearchWrapper>
        <RowWrapper>
          <TH>
            <Checkbox
              checked={searchedOffers.length === selectedOffers.length}
              onChange={handleAssignAllOffers}
              color='primary'
              style={{
                transform: 'scale(1.3)',
              }}
            />
          </TH>
          <TH>Select All Offers</TH>
          {/* <TH>Active</TH> */}
        </RowWrapper>
        {currentPageOffers.map((offer, index) => (
          <RowWrapper
            key={index}
            hoverBGColor='#f1f1fa'
            onClick={(e) => handleAssignOffers(e, offer.offer_id)}
          >
            <TD bgColor='yellow'>
              <Checkbox
                checked={selectedOffers.includes(offer.offer_id)}
                onChange={(e) => handleAssignOffers(e, offer.offer_id)}
                color='primary'
                style={{
                  transform: 'scale(1.3)',
                }}
              />
            </TD>
            <TD isAssigned={selectedOffers.includes(offer.offer_id)}>
              {offer.title}

              {!offer.is_active && (
                <>
                  <span
                    style={{
                      marginLeft: '5px',
                      marginRight: '5px',
                    }}
                  >
                    {'-'}
                  </span>
                  <span>Inactive</span>
                </>
              )}
            </TD>
            {/* <TD isAssigned={selectedOffers.includes(offer.offer_id)}>
              <Checkbox
                checked={offer.is_active}
                color='primary'
                style={{
                  transform: 'scale(1.2)',
                }}
              />
            </TD> */}
          </RowWrapper>
        ))}
        <PaginationWrapper>
          <PaginationControl
            response={{
              ...currentPageOffers,
              page: requestParams.page_number,
              page_size: requestParams.page_size,
              count: allOffers.length,
            }}
            requestParams={requestParams}
            // updateAction={getOffersEngine}
            type='offers'
          />
        </PaginationWrapper>
        <ButtonWrapper>
          <Left>
            <CancelButton onClick={handleReset}>Cancel</CancelButton>
          </Left>
          <Right>
            <Button onClick={handleAddOffers} disabled={isSaveDisabled()}>
              Save
            </Button>
          </Right>
        </ButtonWrapper>
      </StyledCard>
    </Dialog>
  );
};
function mapStateToProps(state) {
  return {
    allOffers: state.OfferEngineReducer.allOffersEngine,
    requestParams: state.OfferEngineReducer.requestParams,
  };
}
export default connect(mapStateToProps, actions)(FilterOfferModal);
